module.exports = "mutation ($id: ID!, $data: PurchaseUpdate!) {\n  PurchaseUpdate(id: $id, data: $data) {\n    id\n  }\n}\n"